import { ae as trackNewsletterSubscribed, af as serializeData } from './app-chunk-common-BPZAsnhF.js';

const subscribeUrl =
  "https://manage.kmail-lists.com/ajax/subscriptions/subscribe";

/**
 * @param {string} listId
 * @param {string} email
 * @param {object} fields
 */
const addUserToList = async (listId, email, fields) => {
  const data = {
    g: listId,
    $fields: Object.keys(fields),
    email: email,
    ...fields,
  };

  const options = {
    method: "POST",
    headers: {
      "cache-control": "no-cache",
      "content-type": "application/x-www-form-urlencoded",
    },
    body: serializeData(data),
  };

  await fetch(subscribeUrl, options);
  return true;
};
/**
 * @param {HTMLElement} widget
 * @param {HTMLFormElement} form
 */
const disableForm = (widget, form) => {
  widget.dataset.status = "submitting";
  form.style.pointerEvents = "none";
  // @ts-ignore
  form.querySelector("button").disabled = true;
};

/**
 * @param {HTMLElement} widget
 * @param {HTMLFormElement} form
 * @param {"" | "error"} status
 */
const enableForm = (widget, form, status = "") => {
  widget.dataset.status = status;
  form.style.pointerEvents = "";
  // @ts-ignore
  form.querySelector("button").disabled = false;
};

/**
 * @param {HTMLElement} widget
 * @param {HTMLFormElement} form
 * @param {string} msg
 */
const showError = (widget, form, msg) => {
  /**
   * @type {HTMLElement|null} errorMsg
   */
  const errorMsg = form.querySelector(".widget-newsletter-form__error-msg");

  if (errorMsg) {
    errorMsg.innerText = msg;
  }

  enableForm(widget, form, "error");
};

/**
 * @param {HTMLElement} widget
 * @param {HTMLFormElement} _form
 */
const showSuccess = (widget, _form) => {
  widget.dataset.status = "submitted";
};

var initNewsletterWidgets = () => {
  /**
   * @type {NodeListOf<HTMLFormElement>} forms
   */
  const forms = document.querySelectorAll(".widget-newsletter-form");

  forms.forEach((form) => {
    form.addEventListener("submit", async (e) => {
      /**
       * @type {HTMLFormElement}
       */
      // @ts-ignore
      const form = e.target;
      e.preventDefault();

      /**
       * @type { HTMLElement|null} widget
       */
      const widget = form.closest(".widget-newsletter");

      if (!widget) {
        return;
      }

      const listId = widget.dataset.listId;
      const source = widget.dataset.source || "widget-newsletter-form";

      if (!listId) {
        console.warn("No Klaviyo list id form widget-newsletter-form");
        return;
      }

      /**
       * @type {HTMLInputElement | null} emailInput
       */
      const emailInput = form.querySelector("input[name='email']");

      if (!emailInput) {
        return;
      }

      disableForm(widget, form);

      const email = emailInput.value.trim();

      if (!email) {
        showError(widget, form, "Please enter a valid email");
        return;
      }

      try {
        await addUserToList(listId, email, { $source: source });
        showSuccess(widget, form);

        /**
         * @type {HTMLElement|null} btnTextElement
         */
        const btnTextElement = form.querySelector(
          ".widget-newsletter-form__button-text"
        );

        const buttonText = btnTextElement
          ? btnTextElement.innerText.trim()
          : "missing";

        trackNewsletterSubscribed(email, buttonText, source);
      } catch (err) {
        showError(
          widget,
          form,
          "We could not subscribe you to our mailing list, please try again later."
        );
        console.error("Klaviyo submission error", err);
      }
    });
  });
};

export { addUserToList as a, initNewsletterWidgets as i };
